module.exports = __webpack_public_path__ + "static/media/Chat.40006445.svg";